'use client';

import React, { useEffect } from 'react';

import LoadingIcon from '@repo/ui/components/Icon/LoadingIcon';

import { SpinnerWrapper, Wrapper } from './styles';

type FullScreenLoaderProps = {
  opacity?: number;
  isDark?: boolean;
  children?: React.ReactNode;
};

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  opacity,
  isDark,
  children,
}) => {
  useEffect(() => {
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow || 'unset';
    };
  }, []);

  return (
    <Wrapper isDark={isDark} opacity={opacity}>
      <SpinnerWrapper>
        <LoadingIcon height="40px" />
      </SpinnerWrapper>
      {children}
    </Wrapper>
  );
};

export default FullScreenLoader;
